module.exports = __webpack_public_path__ + "img/horizontal-logo-pink-th.2429f1ba.svg";